<template>
  <div class="px-4 relative lg:h-full lg:overflow-auto">
    <div class="py-8 px-4 border-b border-black">
      <h3 class="text-xs uppercase mb-4 tracking-widest">OFFICIAL PARTNERS</h3>
      <div class="space-y-8">
        <img
        class="h-10 mb-4"
        src="../assets/logos/ville-geneve.svg"
        alt="Ville de Genève"
      />
      <img
        class="h-18"
        src="../assets/logos/canton-geneve.svg"
        alt="Canton de Genève"
      />
      </div>
    </div>
    <div class="py-8 px-4 border-b border-black">
    
      <h3 class="text-xs uppercase mb-6 tracking-widest">Donors and foundations</h3>
      <div class="space-y-8">
        <img
        class="h-8 mb-4"
        src="../assets/logos/loterie-romande.svg"
        alt="Loterie Romande"
      />
      <img class="h-10 mb-4" src="../assets/logos/1875.svg" alt="1875 Finance" />
      <img
        class="h-5 mb-4"
        src="../assets/logos/Bloomberg.svg"
        alt="Bloomberg"
      />
      <img
        class="h-4 mb-4"
        src="../assets/logos/mob.svg"
        alt="La Mobilière"
      />
      <img
        class="h-12 mb-4"
        src="../assets/logos/leenaards.svg"
        alt="Fondation Leenaards"
      />
      <img
        class="h-4 mb-4"
        src="../assets/logos/arsenic.svg"
        alt="Bloomberg"
      />
      <img class="h-2 mb-4" src="../assets/logos/vrm.svg" alt="Fondation VRM" />
      <img
        class="h-6"
        src="../assets/logos/ernst-olga.svg"
        alt="Ernst und Olga Gubler-Hablützel Stiftung"
      />
       <img
        class="h-6"
        src="../assets/logos/tpg.png"
        alt="TPG"
      />
      </div>
      
    </div>
    <div class="pt-8 lg:pb-8 px-4">
      
      <h3 class="text-xs uppercase mb-6 tracking-widest">cultural partners</h3>
      <div class="space-y-8">
        <img
        class="h-10 mb-4"
        src="../assets/logos/fcac.svg"
        alt="FCAC"
      />
      <img
        class="h-8 mb-4"
        src="../assets/logos/head.svg"
        alt="Bloomberg"
      />
      <img
        class="h-6 pt-2 mb-4"
        src="../assets/logos/moca-taipei.svg"
        alt="La Mobilière"
      />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
